(function () {
  const kiwiVideos = [
    {
      containerId: 'ks-video-container',
      videoId: '268085946',
      thumbSelector: '.ks-video-thumb'
    },
    {
      containerId: 'ks-video-container-268090220',
      videoId: '268090220',
      thumbSelector: '.ks-video-thumb-268090220'
    },
    {
      containerId: 'ks-video-container-268091417',
      videoId: '268091417',
      thumbSelector: '.ks-video-thumb-268091417'
    }
  ];

  const initializedVideoThumbs = new WeakSet();
  const videoThumbnails = new Map();

  function getVideoThumbnail(videoId) {
    if (!videoThumbnails.has(videoId)) {
      const request = fetch(
        `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`
      ).then((res) => {
        if (!res.ok) throw new Error('Vimeo thumbnail unavailable');
        return res.json();
      }).then((data) => {
        if (!data.thumbnail_url) throw new Error('Vimeo thumbnail missing');
        return data.thumbnail_url;
      }).catch((error) => {
        videoThumbnails.delete(videoId);
        throw error;
      });
      videoThumbnails.set(videoId, request);
    }
    return videoThumbnails.get(videoId);
  }

  function setupKiwiVideo(config) {
    const container = document.getElementById(config.containerId);
    const thumbWrapper = container?.querySelector(config.thumbSelector);
    const thumbImg = thumbWrapper?.querySelector('img');
    if (!thumbWrapper || !thumbImg || initializedVideoThumbs.has(thumbWrapper)) return;
    initializedVideoThumbs.add(thumbWrapper);

    // Cache thumbnails across colors, but bind each newly rendered Play button.
    thumbImg.style.visibility = 'hidden';
    getVideoThumbnail(config.videoId).then((url) => {
      if (!thumbImg.isConnected) return;
      thumbImg.src = url;
      thumbImg.style.visibility = '';
    }).catch(() => {
      // Keep Play usable even if Vimeo cannot supply a preview image.
    });
    const playButton = thumbWrapper.querySelector('button');
    if (playButton) {
      playButton.type = 'button';
      playButton.setAttribute('aria-label', 'Play sizing video');
    }
    thumbWrapper.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const iframeWrapper = document.createElement('div');
      iframeWrapper.style.position = 'relative';
      iframeWrapper.style.paddingTop = '56.25%';
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${config.videoId}?autoplay=1&title=0&byline=0&portrait=0`;
      iframe.title = 'Sizing video';
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframeWrapper.appendChild(iframe);
      container.replaceChildren(iframeWrapper);
    });
  }

  let videoSetupPending = false;
  function scheduleVideoSetup() {
    if (videoSetupPending) return;
    videoSetupPending = true;
    requestAnimationFrame(() => {
      videoSetupPending = false;
      kiwiVideos.forEach(setupKiwiVideo);
    });
  }
  function watchKiwiVideos() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    new MutationObserver(scheduleVideoSetup).observe(main, {
      childList: true, subtree: true
    });
    scheduleVideoSetup();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchKiwiVideos, { once: true });
  } else {
    watchKiwiVideos();
  }

  document.addEventListener('theme-drawer:close', function (event) {
    const drawer = event.target;

    drawer.querySelectorAll('iframe').forEach((iframe) => {
      if (iframe.src.includes('player.vimeo.com')) {
        iframe.contentWindow?.postMessage(
          JSON.stringify({ method: 'pause' }),
          'https://player.vimeo.com'
        );
      }

      if (
        iframe.src.includes('youtube.com') ||
        iframe.src.includes('youtube-nocookie.com')
      ) {
        iframe.contentWindow?.postMessage(
          JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: []
          }),
          '*'
        );
      }
    });
  });
})();
(function () {
  function moveFrequentlyBoughtTogether() {
    const anchor = document.getElementById('blacktie-fbt-anchor');
    const fbt = document.querySelector('.cbb-frequently-bought-container');

    if (!anchor || !fbt) return false;

    if (fbt.previousElementSibling === anchor) return true;

    anchor.insertAdjacentElement('afterend', fbt);
    return true;
  }

  const interval = setInterval(function () {
    if (moveFrequentlyBoughtTogether()) {
      clearInterval(interval);
    }
  }, 300);

  setTimeout(function () {
    clearInterval(interval);
  }, 10000);
})();
/* PDP - Hide FourSixty UGC area when no posts exist */

(function () {
  const ugcSectionIds = [
    'shopify-section-template--23291210334433__section_YpEyzN',
    'shopify-section-template--23291210334433__custom_liquid_n4JKeF',
    'shopify-section-template--23291210334433__section_iNdYzp'
  ];

  const setUgcVisibility = (show) => {
    ugcSectionIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        section.style.display = show ? '' : 'none';
      }
    });
  };

  const checkFourSixty = () => {
    const container = document.querySelector('#foursixty-hideable-container');

    if (!container) return;

    const hasPosts =
      container.querySelector('.fs-has-posts') ||
      container.querySelectorAll('.fs-timeline-entry').length > 0;

    setUgcVisibility(!!hasPosts);
  };

  const initFourSixtyCheck = () => {
    const container = document.querySelector('#foursixty-hideable-container');

    if (!container) return;

    const observer = new MutationObserver(() => {
      checkFourSixty();
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    setTimeout(checkFourSixty, 1500);
    setTimeout(checkFourSixty, 3000);
    setTimeout(checkFourSixty, 5000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFourSixtyCheck);
  } else {
    initFourSixtyCheck();
  }
})();
/* PDP - Hide Instafeed area when no product posts exist
   without blocking Instafeed from loading */
(function () {
  const sectionIds = [
    'shopify-section-template--23291210334433__section_xHptET',
    'shopify-section-template--23291210334433__1789257396efe8d53b',
    'shopify-section-template--23291210334433__section_bkeJrB'
  ];

  const widgetSectionId =
    'shopify-section-template--23291210334433__1789257396efe8d53b';

  let observer;

  function getSections() {
    return sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);
  }

  function setPending() {
    getSections().forEach((section) => {
      section.style.opacity = '0';
      section.style.visibility = 'hidden';
      section.style.pointerEvents = 'none';
    });
  }

  function showInstafeed() {
    getSections().forEach((section) => {
      section.style.opacity = '';
      section.style.visibility = '';
      section.style.pointerEvents = '';

      section.style.maxHeight = '';
      section.style.overflow = '';
      section.style.marginTop = '';
      section.style.marginBottom = '';
      section.style.paddingTop = '';
      section.style.paddingBottom = '';
    });
  }

  function collapseInstafeed() {
    getSections().forEach((section) => {
      section.style.opacity = '0';
      section.style.visibility = 'hidden';
      section.style.pointerEvents = 'none';

      section.style.maxHeight = '0';
      section.style.overflow = 'hidden';
      section.style.marginTop = '0';
      section.style.marginBottom = '0';
      section.style.paddingTop = '0';
      section.style.paddingBottom = '0';
    });
  }

  function initInstafeedVisibility() {
    const widgetSection = document.getElementById(widgetSectionId);

    if (!widgetSection) return;

    /*
      IMPORTANT:
      Do NOT use display:none here.
      Instafeed needs to remain rendered so its lazy loader can initialize.
    */
    setPending();

    function hasPosts() {
      return (
        widgetSection.querySelector(
          '.instafeed-new-layout-wrapper img[src]'
        ) ||
        widgetSection.querySelector(
          '.instafeed-new-layout-wrapper a[href]'
        )
      );
    }

    function checkInstafeed() {
      if (hasPosts()) {
        showInstafeed();

        if (observer) {
          observer.disconnect();
        }

        return true;
      }

      return false;
    }

    /* Check immediately */
    if (checkInstafeed()) return;

    /*
      Watch Instafeed while it builds the gallery.
      Attribute watching also catches lazy-loaded image src changes.
    */
    observer = new MutationObserver(function () {
      checkInstafeed();
    });

    observer.observe(widgetSection, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'class', 'style']
    });

    /*
      If nothing has appeared after 3 seconds,
      collapse the empty area — but keep watching in case
      Instafeed finishes unusually late.
    */
    setTimeout(function () {
      if (!checkInstafeed()) {
        collapseInstafeed();
      }
    }, 3000);

    /*
      Final cleanup after 10 seconds.
    */
    setTimeout(function () {
      if (!checkInstafeed()) {
        collapseInstafeed();

        if (observer) {
          observer.disconnect();
        }
      }
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initInstafeedVisibility
    );
  } else {
    initInstafeedVisibility();
  }
})();
/* Keep Kiwi charts in sync with Horizon Combined Listings section replacements. */
(function () {
  let current = null;
  let timer;
  let retries = 0;

  function refreshKiwi() {
    const dataNode = document.querySelector('[data-blacktie-kiwi-product]');
    const drawer = dataNode?.closest('theme-drawer');
    const host = drawer?.querySelector('.ks-container-app-block');
    if (!dataNode || !host) return;
    let productData;
    try { productData = JSON.parse(dataNode.textContent); }
    catch (error) { return; }
    if (!productData.product) return;

    // Leave the first page load to Kiwi's own app block.
    if (!current) {
      current = { product: productData.product, host };
      return;
    }
    if (current.product === productData.product && current.host === host) return;
    if (!window.ks?.loadSizing) {
      if (retries++ < 50) timer = setTimeout(refreshKiwi, 200);
      return;
    }
    retries = 0;
    current = { product: productData.product, host };
    // A separate target keeps a slow response for a previous color detached.
    const target = document.createElement('div');
    target.className = 'blacktie-kiwi-chart-target';
    host.replaceChildren(target);
    window.KiwiSizing = window.KiwiSizing || {};
    window.KiwiSizing.data = {
      ...productData,
      fallbackToBlockPosition: true
    };
    window.ks.loadSizing({
      productData,
      options: { el: target, calculatorEl: target, injectionOrder: 2 }
    });
  }

  function scheduleKiwi() {
    clearTimeout(timer);
    timer = setTimeout(refreshKiwi, 80);
  }
  function startKiwiSync() {
    refreshKiwi();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(scheduleKiwi).observe(main, {
      childList: true, subtree: true, characterData: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startKiwiSync, { once: true });
  } else {
    startKiwiSync();
  }
})();
